/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { InvalidConsideredOption, Option, isValidOption } from '../../types';
import { Text } from '@cimpress-ui/react';
import { OptionStatus } from './OptionStatus';
import { IDPStatus } from './IDPStatus';
import { isUndefined } from 'lodash';

export const Rank = ({ option, halfWeight }: { option: Option | InvalidConsideredOption; halfWeight?: boolean }) => {
  const containerStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  `;

  const rankStyle = css`
    background-color: var(--cim-border-base);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    font-size: ${halfWeight ? '0.8rem' : '1.2rem'};
    font-weight: ${halfWeight ? 400 : 600};
    line-height: 22px;
    height: 46px;
    min-width: 4.7rem;
    justify-content: center;
    text-align: center;

    .rankNumber {
      line-height: 24px;
      font-size: ${halfWeight ? '1.2rem' : '1.8rem'};
      font-weight: ${halfWeight ? 500 : 700};
    }

    @container (max-width: 500px) {
      padding: 0.4rem 0 0.8rem;
      height: 100%;
      justify-content: center;
    }
  `;

  return (
    <div css={containerStyle} data-cim-style-root>
      <div css={rankStyle} data-testid="fulfillment-option-rank">
        <Text as="span">Rank</Text>
        <Text as="span" UNSAFE_className="rankNumber">
          {isValidOption(option) && option.rank ? option.rank : 'N/A'}
        </Text>
      </div>
      <OptionStatus option={option} />
      {!isUndefined(option.idpResult) && <IDPStatus isValid={option.idpResult} />}
    </div>
  );
};
